/**
 * Transform LV4 items to SelectedSkillStandard format
 */
import { ILvl4Item } from 'pages/NewProject/components/ProjectSkillsStandards/interfaces'
import { SelectedSkillStandard } from '../../../../types'

export const transformToSelectedItems = (items: ILvl4Item[]): SelectedSkillStandard[] =>
  items.map(item => ({
    id: item.id,
    name: item.name,
    type: (item.type || 'content') as 'content' | 'skill',
    breadcrumb: item.breadcrumb || `${item.lv1Name || ''} > ${item.lv2Name || ''}`,
    originalCodes: item.originalCodes || '',
    color: item.color || '#6c757d',
    lv1Name: item.lv1Name,
    lv2Name: item.lv2Name,
    lv1ID: item.lv1ID,
    lv2ID: item.lv2ID,
  }))
